<template>
  <!--  <v-dialog-->
  <!--    v-model="dialog"-->
  <!--    width="360px">-->
  <!--    <div class="dialog-container">-->
  <!--      <h2>Snooze Ticket</h2>-->
  <!--      <template v-if="!snoozeStatus">-->
  <!--        <div class="form-item">-->
  <!--          <span>Snooze Until</span>-->
  <!--          <v-datetime-picker v-model="dateTime" />-->
  <!--        </div>-->
  <!--        <v-button-->
  <!--          type="info"-->
  <!--          @click="changeDateTime(0)">4 Hours</v-button>-->
  <!--        <v-button-->
  <!--          type="info"-->
  <!--          @click="changeDateTime(1)">1 Day</v-button>-->
  <!--        <v-button-->
  <!--          type="info"-->
  <!--          @click="changeDateTime(2)">2 Days</v-button>-->
  <!--        <v-button-->
  <!--          type="info"-->
  <!--          @click="changeDateTime(3)">7 Days</v-button>-->
  <!--        <v-checkbox v-model="updateUnsnooze">Or until insurer/policyholder update</v-checkbox>-->
  <!--        <div class="dialog-footer">-->
  <!--          <div>-->
  <!--            <v-button @click="dialog = false">Cancel</v-button>-->
  <!--          </div>-->
  <!--          <div>-->
  <!--            <v-button-->
  <!--              type="danger"-->
  <!--              @click="handlerSnooze">Snooze</v-button>-->
  <!--          </div>-->
  <!--        </div>-->
  <!--      </template>-->
  <!--      <template v-else>-->
  <!--        <p>This ticket has been snoozed.</p>-->
  <!--        <v-button-->
  <!--          type="primary"-->
  <!--          @click="handlerDone">Done</v-button>-->
  <!--      </template>-->
  <!--    </div>-->
  <!--  </v-dialog>-->
  <dialog-component
    :dialogData="dialogData"
    :isShow="dialog"
    :isPlain="true"
    :width="400"
    @cancel="dialog=false"
    @rightNext="handlerUnsnooze"
    @next="handlerSnooze">
    <template v-if="!snoozeStatus">
      <div class="snooze-body">
        <div class="form-item">
          <span>Snooze Until</span>
          <v-datetime-picker v-model="dateTime" />
        </div>
        <v-button
          @click="changeDateTime(0)">4 Hours</v-button>
        <v-button
          @click="changeDateTime(1)">1 Day</v-button>
        <v-button
          @click="changeDateTime(2)">2 Days</v-button>
        <v-button
          @click="changeDateTime(3)">7 Days</v-button>
        <v-checkbox v-model="updateUnsnooze">Or until insurer/policyholder update</v-checkbox>

      </div>
    </template>
  </dialog-component>
</template>

<script>
import { setTicketSnooze,setTicketUnsnooze} from '@/api/ticket'
import dayjs from 'dayjs'
export default {
  name: 'Snooze',
  props: {
    ticketId: {
      type: [String, Number],
      default: ''
    },
    form: {
      type: Object,
      default: ()=>({})
    },
  },
  data() {
    return {
      dialog: false,
      snoozeStatus: false,
      dateTime: '',
      updateUnsnooze: false
    }
  },
  computed:{
    dialogData() {
      let {is_snooze} = this.form || {}
      let params = {
        title: 'Snooze Ticket'
      }
      params.buttonRightText = 'Snooze'
      if (is_snooze==1)
      {
        params.buttonRightText = 'Save'
        params.buttonFirstRightText = 'Unsnooze'
      }
      return params
    }
  },
  watch:{
    form:{
      immediate:true,
      handler(val){
        let {snooze_until,update_unsnooze} = val||{}
        this.dateTime = snooze_until||''
        this.updateUnsnooze = update_unsnooze==1?true:false
      }
    }
  },
  methods: {
    handleNext(){
      this.isShow = false
      this.$emit('continue')
    },
    changeDialog() {
      this.snoozeStatus = false
      this.dialog = !this.dialog
    },
    handlerDone() {
      this.dialog = false
      this.$emit('success')
    },
    changeDateTime(type) {
      const time = [
        dayjs().add(4, 'hours').format('YYYY-MM-DD HH:mm'),
        dayjs().add(1, 'days').format('YYYY-MM-DD HH:mm'),
        dayjs().add(2, 'days').format('YYYY-MM-DD HH:mm'),
        dayjs().add(7, 'days').format('YYYY-MM-DD HH:mm')
      ]
      this.dateTime = time[type]
    },
    handlerUnsnooze(){
      this.dialog = false
      this.network().setTicketUnsnooze()
    },
    handlerSnooze() {
      this.dialog = false
      this.network().setTicketSnooze()
    },
    network() {
      return {
        setTicketSnooze: async () => {
          const { data } = await setTicketSnooze({
            ticket_id: this.ticketId,
            snooze_until: this.dateTime,
            update_unsnooze: this.updateUnsnooze? 1: 0
          })
          this.snoozeStatus = true
          this.$emit('success')
        },
        setTicketUnsnooze: async () => {
          let arr = []
          arr.push(this.ticketId)
          const { data } = await setTicketUnsnooze({
            ticket_id: arr,
          })
          this.$emit('success')
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
 .dialog-container {
    padding: 15px;
    .el-checkbox {
      margin: 10px 0;
    }
    p {
      padding-bottom: 15px;
    }
    .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
    }
   .snooze-body{
     .form-item{
       padding-bottom: 20px;
     }
      .el-button{
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.15px;
        color: #24292E;
        width: 81px;
        &+.el-button {
          margin-left: 15px;
        }
      }
     .el-checkbox{
       margin-top: 20px;
       align-items: flex-end;
     }
   }
  }
</style>
